module.exports = __webpack_public_path__ + "media/toolkits/icon-2-screening-47c44974.svg";